import React from 'react';
import { Calendar as ReactCalendar } from 'react-calendar';
import moment from 'moment';
import {
    ChevronLeft,
    ChevronRight,
} from 'react-feather';
import 'react-calendar/dist/Calendar.css';
import { DAY_OF_WEEK } from '../../constants/DateFormats/DateFormats';
import { EN } from '../../constants/Locale/Locale';
import './Calendar.scss';

/**
 * @property {string} selectedDate - date selected on the calendar
 * @property {string} minDate - minimum date to show on calendar
 * @property {string} maxDate - maximum date to show on calendar
 * @property {string} returnValue - Which dates shall be passed by the calendar to the onChange function and onClick{Period} functions. Can be "start", "end" or "range"
 * @property {boolean} open - if the calendar is open or not. used to control the class of the element for animation purposes
 * @property {function} onChange - function to run when selection is changed
 * @property {function} onClickDay - function to run when a day is selected. doesn't always fire the onChange function when a day is clicked (for example date ranges on first click)
 * @property {boolean} selectRange - true if we are selecting a range. false if we only want to select a single day
 * @property {Ref} calendarInputRef - Ref created using React.createRef
 */
export function Calendar(props) {
    const {
        selectedDate,
        minDate,
        maxDate,
        returnValue,
        open,
        onClickDay,
        onChange,
        selectRange,
        calendarInputRef,
        userLocale = EN,
        disableClickOnNeighborMonth,
        activeStartDate,
        onActiveStartDateChange,
    } = props;
    return (
        <ReactCalendar
            calendarType="US"
            className={[
                'react-calendar-custom',
                open ? 'react-date-picker__calendar--open' : 'react-date-picker__calendar--closed',
                disableClickOnNeighborMonth ? 'react-calendar__disable-neighbor-month-click' : '',
            ].join(' ').trim()}
            defaultView="month"
            formatShortWeekday={(locale, date) => moment(date).format(DAY_OF_WEEK)}
            inputRef={calendarInputRef}
            locale={userLocale}
            maxDate={maxDate}
            maxDetail="month"
            minDate={minDate}
            minDetail="decade"
            next2Label={null}
            nextLabel={<ChevronRight size={13} />}
            onChange={onChange}
            onClickDay={onClickDay}
            prev2Label={null}
            prevLabel={<ChevronLeft size={13} />}
            returnValue={returnValue}
            selectRange={selectRange}
            value={selectedDate}
            activeStartDate={activeStartDate}
            onActiveStartDateChange={onActiveStartDateChange}
        />
    );
}
export default Calendar;
